import React from 'react';

const TermsOfServicePage = () => {
  const today = new Date();
  const formattedDate = today.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="max-w-4xl mx-auto py-10 px-4 sm:px-6 lg:px-8 text-gray-300">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
          Terms of Service for TubeTactix
        </h1>
        <p className="mt-4 text-lg text-gray-400">
          Last updated: {formattedDate}
        </p>
      </div>

      <div className="space-y-10">
        <section>
          <h2 className="text-2xl font-bold mb-4 text-white">
            1. Acceptance of Terms
          </h2>
          <p>
            By accessing and using the TubeTactix web application (the
            "Service"), you accept and agree to be bound by the terms and
            provision of this agreement.
          </p>
          <p className="mt-4">
            By using TubeTactix, you also agree to be bound by the{" "}
            <a
              href="https://www.youtube.com/t/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline"
            >
              YouTube Terms of Service
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4 text-white">
            2. Description of Service
          </h2>
          <p>
            TubeTactix provides YouTube creators with AI-powered research and
            strategy tools. The Service includes a Free plan with a daily credit
            limit and a paid "Pro" subscription plan with a larger monthly
            credit allowance and advanced features. Users of any plan may also
            purchase one-time credit packs.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4 text-white">
            3. User Accounts
          </h2>
          <p>
            You must register for an account to access the Service. You agree to
            provide accurate and complete information when you register with us.
            You are responsible for safeguarding your account and are solely
            responsible for all activities that occur under your account.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4 text-white">
            4. Subscriptions and Billing
          </h2>
          <ul className="list-disc list-inside space-y-2">
            <li>
              <strong>Free Plan:</strong> The Free plan provides a limited
              number of "free credits" that reset daily.
            </li>
            <li>
              <strong>Pro Plan:</strong> The Pro plan is a recurring subscription
              that grants a large number of "subscription credits" each month.
              Pro users also continue to receive the daily "free credits" that
              all users get.
            </li>
            <li>
              <strong>Credit Packs:</strong> Both Free and Pro users can
              purchase "purchased credits" in one-time, non-refundable packs.
              Purchased credits never expire.
            </li>
            <li>
              <strong>Refunds:</strong> All purchases, including Pro plan
              subscriptions and Credit Packs, are final and non-refundable. By
              making a purchase, you acknowledge and agree to this policy.
            </li>
            <li>
              <strong>Credit Usage Order:</strong> When you perform an action,
              credits are deducted in the following order: Free Credits, then
              Subscription Credits, then Purchased Credits.
            </li>
            <li>
              <strong>Cancellations:</strong> If you cancel a Pro subscription,
              you will retain access to Pro features and credits until the end of
              your paid billing period. At the end of the period, your account
              will be downgraded to the Free plan, and any remaining
              subscription_credits will be removed. Purchased_credits will
              remain in your account.
            </li>
            <li>
              <strong>Payment Processor:</strong> All payments are handled by
              our third-party payment processor, Stripe.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4 text-white">
            5. User Conduct and Responsibilities
          </h2>
          <p>
            You agree not to use the Service for any unlawful purpose or in any
            way that interrupts, damages, or impairs the service. You agree not
            to abuse the credit system through the creation of multiple free
            accounts. We reserve the right to terminate accounts that violate
            these terms.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4 text-white">
            6. Limitation of Liability
          </h2>
          <p>
            The Service is provided on an "as is" and "as available" basis.
            TubeTactix does not warrant that the service will be uninterrupted or
            error-free. In no event shall TubeTactix be liable for any direct,
            indirect, incidental, special, or consequential damages arising out
            of the use of or inability to use the Service.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4 text-white">
            7. Governing Law
          </h2>
          <p>These Terms shall be governed by the laws of United Kingdom.</p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4 text-white">
            8. Changes to Terms
          </h2>
          <p>
            We reserve the right to modify these terms from time to time at our
            sole discretion. Therefore, you should review these pages
            periodically. Your continued use of the Service after any such
            change constitutes your acceptance of the new Terms.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4 text-white">
            9. Contact Us
          </h2>
          <p>
            If you have any questions about these Terms, please contact us at:
            contact@tubetactix.com.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfServicePage;